import React from "react";
import "../style/About.css";
import "../style/Common.css";
import "../style/partner.css";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clinic from "../images/clinic.png";
import revenue from "../images/revenue.png";
import enhance from "../images/enhance.png";
import digitize from "../images/digitize.png";
import workflow from "../images/workflow1.jpeg";
import modernized from "../images/modernized1.jpeg";
import marketing from "../images/marketing.jpeg";
import Monthly from "../images/monthly1.jpeg";
import ortho from "../images/orthodontist.jpeg";
import packages from "../images/packages.jpeg";
import refiner from "../images/refiner.jpeg";
import care from "../images/care.jpeg";
import HealthFlow from "../images/healthflow.jpg";
import {
  faCheck,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import AltFAQ from "./FAQ2";
import DoctorContact from "./DoctorContact";
import { useMediaQuery } from "react-responsive";

const benefits = [
  {
    icon: (
      <img
        src={revenue}
        alt="clinic"
        style={{
          width: "40px",
          height: "40px",
        }}
      />
    ),
    title: "Grow Patient Revenue",
    description:
      "Increase earnings by offering modern clear aligner treatments",
  },
  {
    icon: (
      <img
        src={clinic}
        alt="clinic"
        style={{
          width: "40px",
          height: "40px",
        }}
      />
    ),
    title: "Simplify Your Workflow",
    description:
      "Submit a scan or an impression—our team handles the planning, production, and delivery.",
  },
  {
    icon: (
      <img
        src={digitize}
        alt="digitize"
        style={{
          width: "40px",
          height: "40px",
        }}
      />
    ),
    title: "Deliver Trusted Results",
    description:
      "Provide orthodontist-led care with premium aligners your patients rely on",
  },
  {
    icon: (
      <img
        src={enhance}
        alt="Enhance"
        style={{
          width: "40px",
          height: "40px",
        }}
      />
    ),
    title: "Enhance Patient Experience",
    description:
      "Offer a seamless, comfortable aligner journey that builds satisfaction and trust",
  },
];

const sliderContent = [
  {
    image: modernized,
    title: "Seamless Clinic Integration",
    description:
      "Get the support you need to easily add aligners to your workflow.",
  },
  {
    image: ortho,
    title: "Orthodontist-Backed Planning",
    description:
      "Licensed orthodontists plan every case to ensure accuracy and quality.",
  },
  {
    image: workflow,
    title: "Streamlined Case Handling",
    description:
      "We manage planning and production for a smooth, end-to-end process.",
  },
  {
    image: marketing,
    title: "Marketing Support",
    description:
      "Use branded content and social assets designed to boost visibility.",
  },
  {
    image: Monthly,
    title: "Ongoing Case Oversight",
    description:
      "Receive regular updates and support throughout each patient’s journey.",
  },
  {
    image: refiner,
    title: "Included Refinements",
    description: "Refinement aligners are included when needed—no extra fees.",
  },
  {
    image: packages,
    title: "Retainer Solutions",
    description:
      "Offer retainers after treatment to help patients maintain results.",
  },
];

export const faqData = [
  {
    question: "What orthodontic support do we receive?",
    answer:
      "All treatment plans are developed by licensed orthodontists. You'll also receive clear clinical guidance and ongoing support throughout each case.",
  },
  {
    question: "Does Lamaan support my clinic’s marketing?",
    answer:
      "Yes, you’ll have access to a Marketing Kit with branded content and ready-to-use social media materials to help promote aligner treatments at your clinic.",
  },
  {
    question: "Is there a cost to partner with Lamaan?",
    answer:
      "No, there are no setup fees or long-term commitments required to become a partner clinic.",
  },
  {
    question: "Will this disrupt my current workflow?",
    answer:
      "Not at all. Lamaan’s process is built to integrate smoothly into your existing workflow—simply scan and submit, and we take care of the rest.",
  },
];

const NextArrow = ({ onClick }) => (
  <button className="slick-btn next" onClick={onClick}>
    <FontAwesomeIcon icon={faChevronRight} />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="slick-btn prev" onClick={onClick}>
    <FontAwesomeIcon icon={faChevronLeft} />
  </button>
);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const ForDoctors = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <>
      <div className="partner-section">
        <div className="partner-content">
          <h3 className="partner-subtitle">For Dental Professionals</h3>
          <h1 className="partner-title">
            Grow Your Practice with Lamaan
            {isMobile ? "" : " Aligners"}
          </h1>
          <br />
          <br />
          <a href="/for-doctors/#doctor-contact" className="link-btn">
            Partner Today
          </a>
        </div>
      </div>
      <section className="clinic-benefits">
        <h2 className="benefits-title">Transform Your Clinic With Lamaan</h2>
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <div className="benefit-item" key={index}>
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-desc">{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="slider-section">
        <h2 className="slider-title">Why Choose Lamaan?</h2>
        <Slider {...settings}>
          {sliderContent.map((item, index) => (
            <div key={index} className="slide-item">
              <img src={item.image} alt={item.title} className="slide-image" />
              <div className="slide-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </section>
      <section className="orthodontic-solution">
        <div className="solution-content">
          <p className="subtitle">Expert Guidance From Start To Smile</p>
          <h2 className="title">Clear Aligner Treatments Made Simple</h2>
          <p className="description">
            Offering aligner treatments through Lamaan is streamlined and
            efficient. With guided case submission, orthodontist-led planning,
            and high-quality invisible aligners, we support your clinic every
            step of the way to deliver precise, trusted results.
          </p>
        </div>
        <div className="solution-checklist">
          <ul>
            <li>
              <FontAwesomeIcon icon={faCheck} className="check-icon" />
              <span>Streamlined Patient Onboarding</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} className="check-icon" />
              <span>Clinical Support & Resources</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} className="check-icon" />
              <span>Orthodontist-Led Case Management</span>
            </li>
          </ul>
        </div>
      </section>
      <section className="world-class-care">
        <div className="care-image">
          <img
            src={care}
            style={{
              width: "100%",
              height: "500px",
            }}
            alt="World-class care"
          />
        </div>
        <div className="care-content">
          <p className="care-subtitle">
            Trusted By Clinics, Backed By Orthodontists
          </p>
          <h2 className="care-title">
            High-Quality Care, Delivered With Precision
          </h2>
          <p className="care-description">
            Lamaan partners with clinics to provide expertly planned clear
            aligner treatments using licensed orthodontists and top-tier
            materials—ensuring reliable results your patients will trust and
            love.
          </p>
          <a href="/for-doctors/#doctor-contact" className="link-btn">
            Join Our Network
          </a>
        </div>
      </section>
      <section className="healthflow-promo">
        <div className="care-content">
          <p className="care-subtitle">Power Your Clinic, Join the Network</p>
          <h2 className="care-title">Smarter Management, Exclusive Rewards</h2>
          <p className="care-description">
            Clinics choosing Lamaan aligners unlock 6 months free on{" "}
            <a
              href="https://healthflowonline.com"
              target="_blank"
              rel="noreferrer"
              style={{
                color: "#007bff",
              }}
            >
              HealthFlow Online
            </a>
            —the leading cloud-based dental platform built to simplify
            operations and elevate patient care.
          </p>
          <a
            href="https://healthflowonline.com/#contact"
            className="link-btn"
            target="_blank"
            rel="noreferrer"
          >
            Request Demo
          </a>
        </div>
        <div className="healthflow-image">
          <img
            src={HealthFlow}
            style={{
              width: "100%",
              height: "500px",
            }}
            alt="World-class care"
          />
        </div>
      </section>
      <section>
        <AltFAQ faqData={faqData} />
      </section>
      <section className="contact-section-alt" id="doctor-contact">
        <DoctorContact />
      </section>
    </>
  );
};

export default ForDoctors;
